<template src="./login.html"></template>
<script>
import { logEvent } from "firebase/analytics"
import Vue from "vue"
export default {
	name: "Login",
	props: [],
	data() {
		return {
			screenName: "phoneNumber",
			response: null,
			firstName: null,
			lastName: null,

			isLoading: false,
			phoneNumber: null,
			isValidPhoneNumber: false,

			otpNumber: null,

			newPasswordText: null,
			reEnterNewPasswordText: null,

			passwordText: null,
			test: false,
		}
	},
	methods: {
		login() {
			if (this.phoneNumber && this.passwordText) {
				this.isLoading = true
				fetchApi("onLogin", {
					phoneNumber: this.phoneNumber,
					password: this.passwordText,
					client: "web",
				})
					.then((apiResponse) => {
						this.isLoading = false
						this.response = apiResponse
						if (apiResponse && apiResponse.response && apiResponse.response.token) {
							localStorage.setItem("defaulttenant", apiResponse.response.tenantId)
							// this.$analytics.setUserID()
							// window.location.href = "index.html";
							logEvent(this.$analytics, "webUserLogin")
							// https://stackoverflow.com/q/8969878/1619271
							window.location.replace("index.html")
						}
					})
					.catch((error) => {
						console.log(error)
						logEvent(Vue.prototype.$analytics, "webapp_error", {
							data: JSON.stringify(error),
						})
						const err = {
							errno: 500,
							errmsg: "An error occurred while trying to login",
						}
						if (this.response) {
							this.response.err = { errno: 500, errmsg }
							this.response.status = "error"
							this.response.response = null
						} else {
							this.response = { err, status: "error", response: null }
						}
					})
			}
		},
		setPhoneNumber(number, value) {
			if (value && value.hasOwnProperty("isValid")) {
				this.isValidPhoneNumber = value.isValid
			}
			if (value && value.number && value.number.e164) {
				this.phoneNumber = value.number.e164
			}
		},
		onPhoneNumberContinue() {
			if (this.isValidPhoneNumber) {
				this.isLoading = true
				fetchApi("checkPhoneNumber", { phoneNumber: this.phoneNumber })
					.then((apiResponse) => {
						this.isLoading = false
						this.response = apiResponse
						const { err, response, status } = apiResponse
						if (response && response.next) {
							this.screenName = response.next
							this.firstName = response.firstName
							this.lastName = response.lastName

							if (this.screenName === "password" && this.passwordText) {
								const self = this
								setTimeout(() => {
									if (this.passwordText.toString().length === 4) {
										self.$refs.password.otp = Array.from(this.passwordText.toString()).map((x) => Number(x))
									} else {
										self.$refs.password.clearInput()
									}
									//self.$refs.hello.focus();
								}, 100)
							}
						}
					})
					.catch((err) => {
						this.isLoading = false
						logEvent(Vue.prototype.$analytics, "webapp_error", {
							data: JSON.stringify(error),
						})
						console.log(err)
					})
			}
		},
		forgotPassword() {
			this.isLoading = true
			fetchApi("forgotPassword", { phoneNumber: this.phoneNumber })
				.then((apiResponse) => {
					this.isLoading = false
					this.response = apiResponse
					const { err, response, status } = apiResponse
					if (response && response.next) {
						this.screenName = response.next
						const self = this
						setTimeout(() => {
							self.$refs.otp && self.$refs.otp.clearInput()
						}, 100)
					}
				})
				.catch((err) => {
					this.isLoading = false
					console.log(err)
				})
		},
		onOtpNumberContinue() {
			if (this.isOtpValid && this.otpNumber) {
				this.isLoading = true
				fetchApi("verifyOtp", {
					phoneNumber: this.phoneNumber,
					otp: this.otpNumber,
				})
					.then((apiResponse) => {
						this.isLoading = false
						this.response = apiResponse
						const { err, response, status } = apiResponse
						if (response && response.next) {
							this.screenName = response.next
							const self = this
							setTimeout(() => {
								self.$refs.setNewPassword.clearInput()
							}, 100)
						}
					})
					.catch((err) => {
						this.isLoading = false
						console.log(err)
					})
			}
		},
		onNewPasswordTextContinue() {
			if (this.newPasswordText && this.newPasswordText.toString().length >= 4) {
				this.screenName = "reEnterSetNewPassword"
				const self = this
				setTimeout(() => {
					self.$refs.reEnterSetNewPassword.clearInput()
				}, 1)
			}
		},
		onReEnterNewPasswordTextContinue() {
			if (!(this.newPasswordText && this.reEnterNewPasswordText && this.newPasswordText === this.reEnterNewPasswordText)) {
				const err = { errmsg: "New Password does not match" }
				if (this.response) {
					this.response.err = err
				} else {
					this.response = { err }
				}
				return
			}

			this.isLoading = true
			fetchApi("saveNewPassword", {
				phoneNumber: this.phoneNumber,
				otp: this.otpNumber,
				newPassword: this.newPasswordText,
			})
				.then((apiResponse) => {
					this.isLoading = false
					this.response = apiResponse
					const { err, response, status } = apiResponse
					if (response && response.next) {
						//this.screenName = response.next;
						this.passwordText = this.newPasswordText
						//this.passwordText = null;
						const self = this
						setTimeout(() => {
							//self.$refs.hello.focus();
							//self.$refs.loginButton.click();
							this.login()
						}, 1)
					}
				})
				.catch((err) => {
					this.isLoading = false
					console.log(err)
				})
		},
		passWordComplete(value) {
			this.passwordText = value
		},
		handleOnPwdChange(value) {
			if (value.length == 4) {
				this.passwordText = value
			} else {
				this.passwordText = ""
			}
		},
		handleOnOTPChange(value) {
			if (value.length == 6) {
				this.otpNumber = value
			} else {
				this.otpNumber = ""
			}
		},
		handlePinReEnterComplete(value) {
			if (value.length == 4) {
				this.reEnterNewPasswordText = value
				this.passwordText = value
			} else {
				this.reEnterNewPasswordText = ""
				this.passwordText = ""
			}
		},
		handleResetPinComplete(value) {
			if (value.length == 4) {
				this.newPasswordText = value
			} else {
				this.newPasswordText = ""
			}
		},

		otpComplete(value) {
			this.otpNumber = Number(value)
		},
		resetPinComplete(value) {
			this.newPasswordText = value
		},
		resetPinReEnterComplete(value) {
			this.reEnterNewPasswordText = value
			this.passwordText = value
		},
	},
	computed: {
		isOtpValid() {
			if (this.otpNumber) {
				return this.otpNumber.toString().length >= 6
			}
			return false
		},
		isValidPassword() {
			if (this.passwordText) {
				return true
			}
			return false
		},
		hasError() {
			if (this.response && this.response.err && this.response.err.errmsg) {
				this.$refs.password && this.$refs.password.clearInput()
				this.$refs.reEnterSetNewPassword && this.$refs.reEnterSetNewPassword.clearInput()
				return true
			}
			return false
		},
		errmsg() {
			if (this.hasError) {
				return this.response.err.errmsg
			}
			return null
		},
	},
	watch: {
		screenName(newVal, oldValue) {
			if (newVal === "password") {
				setTimeout(() => {
					this.$refs.password.$el.children[0].setAttribute("autocomplete", "new-password")
					const inputs = this.$refs.password.$el.querySelectorAll(".otp-input")
					inputs.forEach((i) => i.setAttribute("autocomplete", "new-password"))
				}, 100)
			}
		},
	},
	mounted() {
		document.body.classList.add("pt-0")
		localStorage.clear()
	},
}

async function fetchApi(apiMethod, requestParams) {
	try {
		const request = await fetch("./" + apiMethod, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(requestParams || {}),
		})

		if (!request.ok) {
			throw Error(request.statusText)
		}

		const response = await request.json()

		response.status = response.err ? "error" : "success"
		return response
	} catch (error) {
		console.log(error)
		logEvent(Vue.prototype.$analytics, "webapp_error", { data: JSON.stringify(error) })
		return {
			err: JSON.stringify(error, Object.getOwnPropertyNames(error)),
			response: null,
			status: "error",
		}
	}
}
</script>
